<template>
  <div class="container-fluid" id="wrapper">
    <mynavbar/>
      <div class="center">
        <h1>Some pic´s </h1>
      </div>   
    <mycarousel/>
    <div class="text-center my-3">
    <b-btn v-b-popover.hover="'For Nothing!'" title="Popover Title">Hover Me</b-btn>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  components: {
    Mycarousel: carouselVue,
    mynavbar:navbarVue
  }
}

import carouselVue from './carousel.vue';
import navbarVue from './navbar.vue';
</script>



// WEBPACK FOOTER //
// src/components/Main.vue